import { inject, type InjectionKey } from 'vue'
import type { OperacoesCatalogoUsuario } from '../catalogo-usuario.tipos'
export const CHAVE_OPERACOES_CATALOGO_USUARIO: InjectionKey<OperacoesCatalogoUsuario> = Symbol('operacoes-catalogo-usuario')
export const usarOperacoesCatalogoUsuario = (): OperacoesCatalogoUsuario => {
  const operacoes = inject(CHAVE_OPERACOES_CATALOGO_USUARIO)
  if (!operacoes) throw new Error('Catalogo de usuario nao foi instalado')
  return operacoes
}
